import { LoadPriority } from '~/hooks/useLoadPriority';
import MicrositeBreakpointImg from '~/components/MicrositeBreakpointImg';

export default function MicrositeMapImg({
	lat,
	lng,
	zoom = 11,
	color = '000000',
}: {
	lat: number;
	lng: number;
	zoom?: number;
	color?: string;
}) {
	return (
		<MicrositeBreakpointImg
			priority={LoadPriority.LOW_PRIORITY}
			url={(_width, height, dpi, viewport) => {
				const prefix = 'https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/';
				let path = `${prefix}pin-l+${color}(${lng},${lat})/${lng - 0.03},${lat},${zoom},0/${viewport}x${height}`;

				if (dpi > 1) {
					path += '@2x';
				}

				const url = new URL(path);
				url.searchParams.set('attribution', 'false');
				url.searchParams.set('logo', 'false');
				url.searchParams.set(
					'access_token',
					'pk.eyJ1IjoicDJzb2Z0d2FyZSIsImEiOiJjbG5ncThucXgwNTBqMmxydm9kcHlyeHo5In0.SWy7DA1JMIEfloyvL41uOQ',
				);

				return url.toString();
			}}
		/>
	);
}
